// extracted by mini-css-extract-plugin
module.exports = {"container":"eeb6c9d23e--container--Ubb22","margin":"eeb6c9d23e--margin--Jzi8s","title":"eeb6c9d23e--title--pGpM3"};